import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemStatusComponent } from '../../components/item-status/item-status.component';
import { ItemMessengerComponent } from '../../components/item-messenger/item-messenger.component';
import { InputSwitchNewComponent } from '../../components/input-switch-new/input-switch-new.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ChatRestServices from '../../services/chat-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import DialogServices from '../../services/dialog.service';
import { ModalChatbotSummaryComponent } from '../modal-chatbot-summary/modal-chatbot-summary.component';
import { ModalChatAvailabilityComponent } from '../modal-chat-availability/modal-chat-availability.component';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'card-chat',
	templateUrl: './card-chat.component.html',
	imports: [
		CommonModule, TranslatePipe, ItemStatusComponent, 
		ItemMessengerComponent, InputSwitchNewComponent, FormsModule
	]
})
export class CardChatComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogServices: DialogServices = inject(DialogServices);
	
	@Input() chat: any;
	@Output() chatChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;

		this.vm.close = this.close;
		this.vm.openSummaryDialog = this.openSummaryDialog;
		this.vm.toggleChatDisabled = this.toggleChatDisabled;
		this.vm.isPreVisitChatOnly = this.angularRoutingHelperService.getCurrentPath() === 'pre-visit-chat/:id';
		if (this.vm.user.businessUserType === 'SERVICE_PROVIDER') {
			// this.angularStateHelperService.scopeWM(this, 'this.vm.chat.id', this.getExtraInfo);
			var currentChat = undefined;
			this.vm.chatChangeListener = this.angularHelperService.createInterval(() => {
				if (this.chat && currentChat !== this.chat.id) {
					currentChat = this.chat.id;
					this.getExtraInfo();
					if (this.vm.user?.service.mentalHealthServiceProvider) {
						this.getBotSummary();
					}
				}
			}, 200);
		}
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.UPDATE_CHAT_STATUS, (event, chatEvent, chatId) => {
			if (this.chat && this.chat.id === chatId) {
				if (chatEvent.eventType === 'CHATBOT_SUMMARY') {
					if (this.vm.user?.service.mentalHealthServiceProvider) {
						this.getBotSummary();
					}
				}
			}
		});
	}
	
	ngOnDestroy() {
		if (this.vm.chatChangeListener) {
			this.angularHelperService.cancelInterval(this.vm.chatChangeListener);
		}
	}
	
	openSummaryDialog() {
		
		// before opening summary dialog check for previsit metadata changes
		this.chatRestServices.getChatById({ id: this.vm.chat.id }, 
			(updatedChat) => {
				this.vm.chat.preVisitMetaData = updatedChat.preVisitMetaData;
				this.vm.chat.open = !this.vm.chat.open;
				this.angularBroadcastHelperService.rootBroadcast("toggleSummaryDrawer", this.vm.chat);
			},
			() => {
				console.error('Failed loading chat');
				this.vm.chat.open = !this.vm.chat.open;
				this.angularBroadcastHelperService.rootBroadcast("toggleSummaryDrawer", this.vm.chat);
			}
		);
	}
	
	openChatBotSummary() {
		this.dialogServices.show({
			controller: ModalChatbotSummaryComponent,
			chatId: this.vm.chat.id,
			summary: this.vm.chatBotSummary
		});
	}
	
	checkChatAvailability() {
		if (this.vm.chatAvailabilityChecking) return;
		this.vm.chatAvailabilityChecking = true;
		this.chatRestServices.getExtraInfo({
			userId: this.vm.chat.privateChatFriend.id
		}).then((extraInfo) => {
			this.vm.chat.extraInfo = extraInfo;
			this.dialogServices.show({
				controller: ModalChatAvailabilityComponent,
				extraInfo: this.vm.chat.extraInfo,
				user: this.vm.chat.privateChatFriend
			});
			this.vm.chatAvailabilityChecking = false;
		}).catch((error) => {
			console.log(error);
			this.vm.chatAvailabilityChecking = false;
		});
	}
	
	toggleChatDisabled = (): void => {
		this.chatRestServices.toggleChatDisabled({
			id: this.vm.chat.id
		}).then(() => {
			this.vm.chat.disabled = !this.vm.chat.disabled;
		}).catch((error) => {
			console.log(error);
		});
	}
	
	getExtraInfo() {
		if (this.vm.chat && !this.vm.chat.extraInfo) {
			this.chatRestServices.getExtraInfo({
				userId: this.vm.chat.privateChatFriend.id
			}).then((extraInfo) => {
				this.vm.chat.extraInfo = extraInfo;
			}).catch((error) => {
				console.log(error);
			});
		}
	}
	
	getBotSummary() {
		this.chatRestServices.getBotSummary({chatId: this.vm.chat.id},
			(res) => {
				if (res && res.summary) {
					this.vm.chatBotSummary = res.summary;
				} else {
					this.vm.chatBotSummary = null;
				}
			},
			(err) => {
				this.vm.chatBotSummary = null;
				console.log(err);
			});
	}
	
	close() {
		this.vm.chat = undefined;
	}
	
}
